import { useState } from 'react';
import { useSnackbar } from 'notistack';

import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractApiErrorMessage } from '../../shared/utils/extract-api-error-message.util';
import { QUOTES_API_PATHS } from '../constants/quotes-paths.constants';

type UseGetQuoteDownloadUrlResult = {
  getDownloadUrl: (id: string) => Promise<string | null>;
  isLoading: boolean;
};

type DownloadUrlResponse = { url: string };

export function useGetQuoteDownloadUrl(): UseGetQuoteDownloadUrlResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);

  const getDownloadUrl = async (id: string): Promise<string | null> => {
    setIsLoading(true);

    try {
      const response = await HttpClient.get<DownloadUrlResponse>(QUOTES_API_PATHS.DOWNLOAD_URL(id));
      return response?.url ?? null;
    } catch (error) {
      enqueueSnackbar(
        extractApiErrorMessage(error, 'Une erreur est survenue lors de la récupération du lien de téléchargement'),
        { variant: 'error' }
      );
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { getDownloadUrl, isLoading };
}
